import React from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import { Link } from "react-router-dom";

const Widgets = () => {
  const userModules = [
    {
      title: "CRM",
      tabs: [
        { name: "Plan", route: "/plan" },
        { name: "Engage", route: "/engage" },
        { name: "Assist", route: "/assist" },
        { name: "Analyze", route: "/analyze" },

      ],
    },
    {
      title: "Operation",
      tabs: [
        { name: "Dashboard", route: "/dashboard" },
        { name: "Advisors", route: "/advisor-list" },
        { name: "Uploader", route: "/uploader" },
        { name: "Leads", route: "/leads" },
        { name: "Client/Prospect", route: "/prospect" },
        { name: "Follow Ups", route: "/follow-ups" },
        { name: "User", route: "/users-list" },
        { name: "Portfolio Review", route: "/portfolio" },
      ],
    },
    {
      title: "Management Console",
      tabs: [
        { name: "Todays's Performance", route: "/management-console/todays-performance" },
        { name: "Score Card", route: "/management-console/score-card" },
        { name: "Annual Performance", route: "/management-console/annual-performance" },
        { name: "Prospect Trend", route: "/management-console/prospect-trend" },
        { name: "Base Management", route: "/management-console/base-management" },
        { name: "Funnel Status", route: "/management-console/funnel-status" },

      ],
    },

  ];


  return (
    <>
      {userModules.map((module, index) => (
        <Row key={index}>
          <Col className="col-12">
            {/* Section Header */}
            <div className="d-flex align-items-center mt-4 mb-3">
              <div
                style={{
                  width: 4,
                  height: 22,
                  backgroundColor: "#0d6efd",
                  borderRadius: 4,
                  marginRight: 10,
                }}
              />
              <h5 className="mb-0 fw-semibold">{module.title}</h5>
            </div>

            <Row>
              {module.tabs.map((tab, idx) => (
                <Col xl={2} md={6} key={idx}>
                  <Card className="hover-shadow">
                    <CardBody>
                      <Link
                        to={tab.route}
                        className="text-decoration-none text-dark"
                      >
                        <h6 className="fw-semibold mb-1">{tab.name}</h6>
                        <p className="text-muted mb-0 fs-13">
                          Manage {tab.name.toLowerCase()}
                        </p>
                      </Link>
                    </CardBody>
                  </Card>
                </Col>
              ))}
            </Row>
          </Col>
        </Row>
      ))}
    </>
  );
};

export default Widgets;
